/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { handleRequestATT } from "./RequestATT";
import { RequestLocation } from "./RequestLocation";
import { RequestPushNotifications } from "./RequestPushNotifications copy";

export const requestPermission = (type: string) => {
  switch (type.toLowerCase()) {
    case "notifications":
      RequestPushNotifications();
      break;
    case "att":
      handleRequestATT();
      break;
    case "location":
      RequestLocation();
      break;
  }
};
